module.exports = __webpack_public_path__ + "static/media/default_pic.84737484.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/default_pic.jpg
// module id = 178
// module chunks = 31